import { Metadata } from "@/types/params.types";

import { SIDEBAR_MESSAGES, SidebarMessages } from "../layout/sidebar";

export type PrivacyPolicyMessages = SidebarMessages & {
  // Title message
  title: string;

  // Introduction section
  introductionTitle: string;
  introduction: string;

  // Sections titles
  sectionsTitles: string;

  // Data Collection section
  dataCollectionDetails: string;

  // Data Usage  section
  dataUsageDetails: string;

  // Data Sharing  section
  dataSharingDetails: string;

  // Data SubjectRights  section
  dataSubjectRightsDetails: string;

  // Security Information Details section
  securityInformationDetails: string;

  //Policy Updates Details section
  policyUpdatesDetails: string;

  // Applicable Legislation Details section
  applicableLegislationDetails: string;
};

const PRIVACY_POLICY_MESSAGES: PrivacyPolicyMessages = {
  // Title message
  title: "Política de Privacidade",

  // Introduction section
  introductionTitle: "Olá! Seja Bem-vindo(a) ao site da TALK2BUY!",
  introduction:
    "Inicialmente, agradecemos muito a sua visita! Saiba que quando você ingressa em nosso portal, você nos confia seus dados e informações. Nos comprometemos a manter essa confiança. \n Nossa Política de Privacidade explicará a você, de forma clara e acessível, quais serão as suas informações e dados coletados, com quem serão compartilhados e em que locais serão armazenados.\n <strong>Ao acessar e navegar por nosso portal, você aceita nossa Política, estando ciente e em total acordo com a forma como utilizaremos as suas informações e seus dados.</strong> \nPara facilitar a sua compreensão, saiba que nossa Política está organizada da seguinte forma:",

  // Sections titles
  sectionsTitles: `1. Informações Coletadas
    2. Como Usamos Seus Dados
    3. Compartilhamento de Dados
    4. Direitos dos Titulares
    5. Proteção das Suas Informações
    6. Atualização da Nossa Política
    7. Legislação Aplicável`,

  // DataCollection section text
  dataCollectionDetails: `<strong>1. INFORMAÇÕES QUE COLETAMOS</strong> \n Para que navegue em nosso portal, nós coletamos os seguintes tipos de informações:
    <strong>i. Informações fornecidas por você:</strong>
    - Dados de cadastro: Quando você se cadastra em nosso site, você nos fornece as seguintes informações: Nome, Telefone, E-mail, Cargo e Empresa.
    - Informações de autenticação: Visando lhe proporcionar um ambiente seguro, podemos solicitar as seguintes informações de identificação e autenticação: Nome, E-mail e Telefone.
    <strong>ii. Informações geradas automaticamente:</strong>
    - Registros de acesso: A TALK2BUY coleta de forma automática os registros de acesso a aplicação, que podem incluir o endereço IP, com data e hora, utilizado para acessar o site da TALK2BUY. Esses dados são de coleta obrigatória, conforme estipulado pela Lei 12.965/2014, mas serão fornecidos para terceiros apenas com a sua autorização expressa ou em razão de decisão judicial.
    - Comunicações com a TALK2BUY: Quando você se comunica com a TALK2BUY, coletamos informações sobre sua comunicação, incluindo metadados como data, IP e hora das comunicações e todo o seu conteúdo, assim como qualquer informação que você escolha fornecer.
    - Cookies e tecnologias semelhantes: Nós utilizamos cookies, isto é, arquivos de texto gerados e armazenados no seu navegador ou aparelho por sites, aplicativos e anúncios online.`,

  dataUsageDetails: `
   <strong>2. COMO USAMOS SEUS DADOS </strong> 

    Nós prezamos muito pela sua privacidade e é justamente por isso que todos os dados e informações sobre você são tratadas com a mais alta confidencialidade, sendo usados somente para os fins ora descritos e por você conhecidos e autorizados.

    <strong>i. Usos autorizados </strong>  

    Poderemos utilizar seus dados para:
    - Permitir que você acesse e utilize todas as funcionalidades do nosso portal;
    - Cumprir obrigações legais.
    - Enviar mensagens, alertas, notificações e atualizações a respeito de suporte ou serviço prestado, produtos, serviços, promoções, notícias, atualizações, eventos e outros assuntos que você possa ter interesse;
    - Detecção e prevenção de fraudes, spam e incidentes de segurança;
    - Verificar ou autenticar as informações fornecidas por você, inclusive comparando a dados coletados de outras fontes;
    - Para qualquer fim que você autorizar no momento da coleta de dados;

    Poderemos, eventualmente, utilizar dados para finalidades diversas das previstas nesta política de privacidade, mas todas elas estarão dentro das suas legítimas expectativas. 
    <strong>O eventual uso dos seus dados para finalidades que não cumpram com essa prerrogativa será feito mediante sua autorização prévia.</strong>
  `,

  dataSharingDetails: `
  <strong>3.COMPARTILHAMENTO DAS INFORMAÇÕES</strong>

  Todas as informações que armazenamos sobre você podem ser consideradas ativos no caso de negociações em que a TALK2BUY fizer parte. Nesse sentido, nos reservamos no direito de, por exemplo, incluir seus dados dentre os ativos da empresa caso esta venha a ser vendida, adquirida ou fundida com outra. 
  <strong>Por meio desta Política você concorda e está ciente desta possibilidade. </strong> 

  A TALK2BUY deverá fornecer seus dados e informações, caso seja requisitado por meio de decisão judicial.
`,

  dataSubjectRightsDetails: `
<strong>4. DIREITOS DOS TITULARES</strong>

Você sempre possuirá direitos relativos à privacidade e à proteção dos seus dados pessoais. Dessa forma, abaixo resumimos todos os direitos que você tem sob as leis brasileiras relativas a proteção de dados, quais sejam:

i. Direito de acesso: Este direito permite que você possa requisitar e receber uma cópia dos dados pessoais que possuímos sobre você.

ii. Direito de retificação: A qualquer momento você poderá solicitar a correção e/ou retificação dos seus dados pessoais, caso identifique que alguns deles estão incorretos. Para tanto, teremos que averiguar a validade das novas informações fornecidas. Você pode retificar os seus dados pessoais através do e-mail lgpd@TALK2BUY.com.br.

iii. Direito de exclusão: Você pode solicitar a exclusão dos dados pessoais que possuímos sobre você. Todos os dados coletados serão excluídos de nossos servidores quando você assim requisitar ou quando estes não forem mais necessários ou relevantes para lhe oferecermos nossos serviços, salvo se houver qualquer outra razão para a sua manutenção, como eventual obrigação legal de retenção de dados ou necessidade de preservação destes para resguardo dos nossos direitos. Para alterar suas informações pessoais ou excluí-las do nosso banco de dados, basta enviar um e-mail para lgpd@TALK2BUY.com.br.

iv. Direito de oposição ao processamento: Você também tem o direito de contestar onde e em que contexto estamos tratando seus dados pessoais para diferentes finalidades.

v. Direito de solicitar anonimização, bloqueio ou eliminação: Você poderá nos requisitar a suspensão do processamento de seus dados pessoais nas seguintes hipóteses: (a) se você quiser que nós estabeleçamos a precisão dos dados; (b) manutenção dos dados mesmo se não precisarmos mais deles, visando exercer ou defender reivindicações legais; ou (c) se você se opor ao uso de seus dados, mas neste cenário precisamos verificar se não temos motivos legítimos para continuar tratando-os.

vi. Direito à portabilidade: Forneceremos a você ou a terceiro por você indicado, seus dados pessoais em formato estruturado e interoperável.

vii. Direito de retirar o seu consentimento: Você tem o direito de revogar o seu consentimento em relação aos termos desta Política de Privacidade. Saiba que caso você retire o seu consentimento, talvez não possamos fornecer determinados serviços.

Alertamos que poderá ser necessário solicitar informações específicas suas para nos ajudar a confirmar sua identidade e garantir seus direitos. Esta é uma medida de segurança que visa impedir a divulgação indesejada de seus dados pessoais a qualquer pessoa que não tenha direito de recebê-los.

Podemos, ainda, entrar em contato para obter mais informações em relação à sua solicitação, a fim de acelerar nossa resposta. Tentamos responder a todas as solicitações dentro de 15 dias. Eventualmente, pode levar mais de 15 dias se sua solicitação for particularmente complexa ou se você tiver feito várias solicitações. Neste caso, iremos comunicá-lo e mantê-lo atualizado sobre o andamento da sua solicitação.
`,

  securityInformationDetails: `
<strong>5. PROTEÇÃO DAS SUAS INFORMAÇÕES</strong>
Todos os seus dados são confidenciais e somente as pessoas com as devidas autorizações terão acesso a eles. A TALK2BUY empenhará todos os esforços razoáveis de mercado para garantir a segurança dos nossos sistemas e dos seus dados. Nossos servidores estão localizados em diferentes locais para garantir estabilidade e segurança, e somente podem ser acessados por meio de canais de comunicação previamente autorizados. \n
Todas as suas informações serão, sempre que possível, criptografadas, caso não inviabilizem o seu uso pela plataforma. A qualquer momento você poderá requisitar cópia dos seus dados armazenados em nossos sistemas. Manteremos os dados e informações somente até quando estas forem necessárias ou relevantes para as finalidades descritas nesta Política, ou em caso de períodos pré-determinados por lei, ou até quando estas forem necessárias para a manutenção de interesses legítimos da TALK2BUY.\n 
Importante esclarecer que não temos como garantir que todos os seus dados em nossa plataforma estarão livres de acessos não autorizados, principalmente caso haja compartilhamento indevido das credenciais necessárias para acessar o nosso aplicativo. \n
Recomendamos que você mantenha sua senha de acesso em local seguro, sendo desaconselhado o compartilhamento desta com terceiros. Você se compromete a notificar a TALK2BUY, imediatamente, através de meio seguro, a respeito de qualquer uso não autorizado de sua conta, bem como o acesso não autorizado por terceiros a esta.`,

  policyUpdatesDetails: `
<strong>6. ATUALIZAÇÕES DA NOSSA POLÍTICA</strong>
A TALK2BUY se reserva no direito de atualizar a nossa Política de Privacidade quantas vezes forem necessárias, a fim de fornecer a você informações mais seguras e melhorar cada vez mais a sua experiência.`,

  applicableLegislationDetails: `
<strong>7. LEGISLAÇÃO APLICÁVEL</strong>
Este documento é regido e deve ser interpretado conforme as leis e atos normativos que compõem o ordenamento jurídico brasileiro. Fica eleito o Foro da Comarca de São Paulo/SP como o único competente para dirimir eventuais questões oriundas do presente documento, com expressa renúncia a qualquer outro.`,

  //Side Bar
  ...SIDEBAR_MESSAGES,
};

export default PRIVACY_POLICY_MESSAGES;

export const PRIVACY_POLICY_METADATA: Metadata = {
  title: "Política de Privacidade",
  description: "Página de Política de Privacidade",
};
